<template>
  <div class="KYCMainVisualInformation">
    <div class="KYCMainVisualInformation__image">
      <div class="KYCMainVisualInformation__sheild show-animation">
        <img
          class="KYCMainVisualInformation__coin show-animation coin-delay"
          width="62px"
          src="~@/assets/img/kyc_info/img_information_coin.png"
        />

        <img
          class="KYCMainVisualInformation__checked show-animation checked-delay"
          width="62px"
          src="~@/assets/img/kyc_info/img_information_checked.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KYCMainVisualInformation",
  data() {
    return {
      infotmation: {
        title: "건전하고 투명한 가상자산거래를\n 위한 고객확인제도(CDD)",
        description:
          "'특정 금융거래정보의 보고 및 이용 등에 관한 법률 제 5조의 2'에 의한 법률적 의무사항으로 금융기관 등이 제공하는 금융거래 및 서비스가 자금세탁 등의 불법행위에 이용되지 않도록 고객의 신원사항 (실지명의, 직업, 주소, 연락처 등), 거래목적 및 자금출처, 실제 소유자 등을 확인하는 절차입니다. ",
        sub_desc:
          "플라이빗은 2021년 내\n 고객확인제도 의무화를 시행할 예정입니다.",
      },
    };
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
.KYCMainVisualInformation {
  width: 100%;

  &__text {
    padding: 0 20px;
  }

  &__image {
    background: url("~@/assets/img/kyc_info/img_information_background.png")
      no-repeat left top / contain;
    width: 328px;
    height: 286px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }

  &__sheild {
    background: url("~@/assets/img/kyc_info/img_information_sheild.png")
      no-repeat center center / contain;
    width: 210px;
    height: 172px;
    position: relative;
    margin: 0 auto;
  }

  &__coin {
    position: absolute;
    top: 50%;
    margin-top: -31px;
    left: -31px;
  }

  &__checked {
    position: absolute;
    top: 50%;
    margin-top: -31px;
    right: -31px;
  }

  &__title {
    font-size: 24px;
    color: #fff;
    font-weight: 500;
    text-align: center;
  }

  &__description {
    font-size: 14px;
    color: #bec3cd;
    font-weight: 300;
    margin-top: 12px;
    word-break: keep-all;
    text-align: center;
  }

  .show-animation {
    animation-duration: 1s;
    animation-name: focus;
    -webkit-animation-duration: 1s;
    -webkit-animation-name: focus;
    animation-fill-mode: forwards;
    transform: scale(0);
  }

  .coin-delay {
    animation-delay: 0.4s;
  }

  .checked-delay {
    animation-delay: 0.6s;
  }

  @keyframes focus {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }
}
</style>
